<template>
  <div>
    <div v-if="linkIsValid === 1">
      <v-dialog v-model="showOpenShareFileDialog" persistent width="600">
        <v-card>
          <v-card-title>
            <p>文件分享</p>
            <v-spacer></v-spacer>
            <p @click="closeDialog" style="float:right;font-size:14px;color:#A6A6A6;cursor:pointer;margin-right: 10px"
               class="iconfontFamily">&#xe60d;</p>
          </v-card-title>
          <v-card-text>
            <div style="height: auto;min-height: 500px;position: relative;padding: 24px 30px 24px 30px">
              <p style="color: black;width: 60%;text-overflow:ellipsis;overflow: hidden;white-space: nowrap;font-weight: 700;font-size: 18px">
                {{fileInfo['fileName']}}</p>
              <div style="display: flex;align-items: center" class="mt-5">
                <div
                    style="border-radius: 50%;width: 30px;height: 30px;background-position: center center;background-repeat:no-repeat;background-size: cover;"
                    :style="{'background-image' : 'url(' + fileInfo['avatar'] + ')'}"></div>
                <div style="font-size: 16px;color: black;margin-left: 10px">{{ fileInfo['nickName'] }}</div>
              </div>
              <div class="preview-img" :style="{'background-image' : 'url(' + fileInfo['thumbnail'] + ')'}">
              </div>
              <div style="display: flex" class="mt-4">
                <p class="item-key">标记数量</p>
                <p class="item-value">{{ fileInfo['labelCount'] }}</p>
              </div>
              <div style="display: flex">
                <p class="item-key">更新时间</p>
                <p class="item-value">{{ fileInfo['modifyTime'] }}</p>
              </div>
              <div style="display: flex">
                <p class="item-key">创建时间</p>
                <p class="item-value">{{ fileInfo['createTime'] }}</p>
              </div>
              <div style="display: flex" class="mt-3">
                <p class="item-key" style="line-height: 21px">使用说明</p>
                <p class="item-value" style="line-height: 21px;word-break: break-word;height: auto">
                  {{ fileInfo['description'] }}</p>
              </div>
              <div style="display: flex" class="mt-3">
                <p class="item-key" style="line-height: 21px">文件简介</p>
                <p class="item-value" style="line-height: 21px;word-break: break-word;height: auto">
                  {{ fileInfo['introduction'] }}</p>
              </div>
              <div style="width: calc(100% - 60px);height: 35px;position: absolute;bottom: 20px;display: flex;justify-content: center">
                <div v-if="fileExist" style="display: flex">
                  <p class="iconfontFamily" style="color: rgba(0,201,81,1)">&#xe687;</p>
                  <p style="color: rgba(0,201,81,1);margin-left: 10px">您已拥有该文件</p>
                </div>
                <div v-if="!fileExist" style="display: flex">
                  <div @click="closeDialog" style="height: 35px;display: flex;align-items: center;justify-content: center;width: 100px;background-color: rgba(245,245,245,1);color: rgba(81,81,81,1);cursor: pointer">取消</div>
                  <div @click="addToMyFile" style="height: 35px;display: flex;align-items: center;justify-content: center;width: 150px;background-color: rgba(42,130,228,1);color: white;cursor: pointer;margin-left: 22px">添加至我的文件</div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div v-if="linkIsValid === 0">
      <v-dialog v-model="showFailTipDialog" persistent width="540">
        <v-card>
          <v-card-title class="tipsDialog-title">
            温馨提示
            <v-spacer></v-spacer>
            <p @click="closeFailTipDialog" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
          </v-card-title>
          <v-card-text class="tipsDialog-mainAreaNoIcon">
            <div style="display: flex;width: 100%;height: 80px;line-height: 80px;justify-content: center;align-items: center">
              <p class="iconfontFamily" style="font-size: 60px;color: dodgerblue;margin-left: -10px">&#xe640;</p>
              <div style="margin-left: 40px;text-align: left">
                <p class="tipsDialog-mainAreaNoIcon-text" style="line-height: 25px">文件打开失败，链接已失效</p>
              </div>
            </div>
            <div class="tipsDialog-mainArea-btnLine">
              <v-btn @click="closeFailTipDialog" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确认</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpenShareFileDialog',
  props: ['showOpenShareFileDialog', 'shareFileCode'],
  data() {
    return {
      fileInfo: '',
      fileExist: false,
      linkIsValid: '',
      showFailTipDialog: true
    }
  },
  methods: {
    closeDialog() {
      console.log('close')
      this.$emit('closeOpenShareFileDialog')
    },
    closeFailTipDialog() {
      this.showFailTipDialog = false
      this.$router.push({
        path: '/globe'
      })
    },
    addToMyFile() {
      let params = new FormData()
      params.append('shareFileCode', this.shareFileCode)
      this.$axios({
        method: 'post',
        url: '/authorApi/z-geo-file/fileSaveFromShare',
        data: params
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          // 跳转到我的文件
          this.$emit('goToMyFolder')

        } else if (resp.status === 5503) {
          this.fileExist = true
        } else {
          console.log('添加分享文件失败')
        }
      })
    },
    getShareFileInfo() {
      this.$axios({
        method: 'get',
        url: '/authorApi/z-geo-file/getShareFileInfo',
        params: {
          shareFileCode: this.shareFileCode
        }
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.fileInfo = resp.data
          this.linkIsValid = 1
        } else if (resp.status === 5502) {
          // 链接失效
          this.linkIsValid = 0
        } else {
          console.log('获取分享文件失败')
        }
      })
    }
  },
  mounted() {
    //删除存储的文件分享码
    if(window.localStorage.getItem('shareFileCode')) {
      window.localStorage.removeItem('shareFileCode');
    }
    this.getShareFileInfo()
  }
}
</script>

<style scoped>
.item-key {
  width: 18%;
  font-size: 16px;
  color: rgba(128, 128, 128, 1);
  height: 38px;
  line-height: 38px;
}

.item-value {
  width: 82%;
  font-size: 16px;
  color: black;
  height: 38px;
  line-height: 38px
}

.preview-img {
  position: absolute;
  top: 20px;
  right: 30px;
  width: 200px;
  height: 150px;
  border: 3px solid white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>